import { IYearSelectOption } from '../interfaces/IYearSelectOption';

export const generateYearsSelectOptions = (yearsArray: number[]): Array<IYearSelectOption> => {
  return yearsArray.map<IYearSelectOption>(year => ({
    id: String(year),
    value: String(year),
    label: String(year),
  }));
};
